/*************************************************************************
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@react-spectrum/icon";

const CustomIcon = props => {
  const IconCls = props.url;
  return (
    <Icon size={props.size} UNSAFE_classname={props.className}>
      <IconCls UNSAFE_classname={props.svgClassName} />
    </Icon>
  );
};

export default CustomIcon;

CustomIcon.propTypes = {
  url: PropTypes.element.isRequired,
  className: PropTypes.string,
  size: PropTypes.string,
  svgClassName: PropTypes.string
};

CustomIcon.defaultProps = {
  className: null,
  svgClassName: null,
  size: "S"
};
